module.exports = __webpack_public_path__ + "img/usuarios_1_mask.c8888df7.svg";